/**
 * @interface
 */
export class CategoryRepository {
  /**
   * @returns {Promise<Category[]>}
   */
  async getAll() {
    throw new Error('Method not implemented');
  }

  /**
   * @param {string} id 
   * @returns {Promise<Category>}
   */
  async getById(id) {
    throw new Error('Method not implemented');
  }
} 